import {Utils} from "../../utils";
import {HomeItemRenderer} from "./home-item-renderer"

export class BookRenderer extends HomeItemRenderer{

	constructor(container:HTMLElement, private bookLink: string, private bookName: string,isForMobile:boolean){
		super(container);
		this.isForMobile = isForMobile;
	}

	public render(){
		var entryHtml = document.createElement("div");
		entryHtml.className = "p_home_book"
		entryHtml.innerHTML = `
<div class='_bookName _type'>${this.bookName}</div>
<div id='dr_issu' data-booklink="${this.bookLink}"></div>`;
		this.renderContainer(this.isForMobile).appendChild(entryHtml);
	}
}
